export const GET_USER = "GET_USER";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const BLOCK_UNBLOCK_SWITCH = "BLOCK_UNBLOCK_SWITCH";

export const GET_HISTORY = "GET_HISTORY";

export const EDIT_COIN = "EDIT_COIN";
